/** Suggested relationship labels for Others Present; free-text write-ins are also allowed. */
export const OTHERS_PRESENT_RELATIONSHIP_TO_CLIENT_OPTIONS = [
  "Doula",
  "Partner / Spouse",
  "Significant Other",
  "Parent",
  "Family Member",
  "Friend",
  "Community Birth Worker",
] as const;

export type OthersPresentRelationshipToClient =
  (typeof OTHERS_PRESENT_RELATIONSHIP_TO_CLIENT_OPTIONS)[number];

/**
 * Form preload placeholder when an others-present row has no relationship extension.
 * Not written back to FHIR on save so legacy rows stay extension-free until edited.
 */
export const OTHERS_PRESENT_UNKNOWN_RELATIONSHIP = "Unknown";
